<template>
    <LayoutBase>
        <div class="full-height grid">
            <nested-post-sidebar :key="group.id" :group="group" v-if="group.type == '2'" :sidebarPosts="sidebarPosts" :category="category"/>

            <div id="content-wrapper" class="app-position">
                <div class="grid grid-bleed">
                    <div id="return-sidebar" class="col-md-2">
                        <router-link :to="{ name: 'view-post', params: { group: this.$route.params.group, post: this.$route.params.post }}" v-if="group.type !== '2'">
                            <i class="icon ion-md-arrow-back"></i> Back
                        </router-link>
                    </div>

                    <div class="col-md-8">
                        <div class="article-wrapper editor-wrapper">
                            <div class="panel">
                                <div class="page-header">
                                    <textarea class="title-input" rows="1" type="text" placeholder="Title" v-model.trim="post.title" style="height: 42px;" v-on:blur="maybeSave"></textarea>
                                </div>

                                <ul class="authors">
                                    <li class="add-author" v-tooltip="'Add an author'">
                                        <search-dialog :id="'author-modal'" :users="post.authors" v-on:author-modal-add-item="addAuthor"></search-dialog>
                                        <a href="#" v-on:click.stop.prevent="openModal('author-modal')" class="avatar avatar-add">
                                            <i class="icon ion-md-person-add"></i>
                                        </a>
                                    </li>
                                    <li v-for="author in post.authors">
                                        <avatar :user="author" :deletable="true" v-on:remove-user="removeAuthor"></avatar>
                                    </li>
                                </ul>

                                <div class="form" v-if="group.type == 4">
                                    <div class="card card--venue" v-if="post.event.venue !== null">
                                        <div class="header">
                                            <div>
                                                <label>Venue:</label>
                                                <h4>{{ post.event.venue }}</h4>
                                            </div>

                                            <button class="btn btn-tiny" @click="resetVenue">
                                                <i class="icon ion-md-close"></i>
                                            </button>
                                        </div>
                                        <img width="100%" :src="'https://maps.googleapis.com/maps/api/staticmap?autoscale=2&scale=2&size=860x220&maptype=roadmap&key=AIzaSyCjz3LIQwN2Ip1jfll0zUrIAvDfTW7A9-4&format=png&visual_refresh=true&markers=size:small%7Ccolor:0xff0000%7Clabel:1%7C' + post.event.venue">
                                    </div>

                                    <div class="form__group" v-if="post.event && post.event.venue === null">
                                        <label class="form__label" for="venue">Event venue</label>
                                        <input type="text" id="venue" name="venue" class="form__control" @keyup="getVenuePredictions"v-model="venue_search" placeholder="Search for a venue by name or address" autocomplete="off">

                                        <div class="predictions">
                                            <div class="prediction" v-for="(prediction, index) in venuePredictions">
                                                <div>
                                                    <input type="radio" v-model="chosenVenue" :value="index" :id="'venue-' + index">
                                                </div>

                                                <label :for="'venue-' + index">{{ prediction.description }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__group">
                                        <label class="form__label" for="event_start_date">Event starts</label>
                                        <flat-pickr
                                            v-model="post.event.starts"
                                            class="form__control"
                                            :config="config_datepicker"
                                            @on-change="updateEndDateOnChange"
                                        ></flat-pickr>
                                    </div>
                                    <div class="form__group">
                                        <label class="form__label" for="event_end_date">Event ends</label>
                                        <flat-pickr
                                            v-model="post.event.ends"
                                            class="form__control"
                                            :config="config_datepicker"
                                        ></flat-pickr>
                                    </div>
                                </div>

                                <div class="article">
                                    <editor v-model="post.content" :group="group" v-on:update="updateDocument"></editor>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div id="editor-sidebar" class="col-md-2">
                        <div class="form">
                            <h3>Status</h3>

                            <div class="publish-status">
                                <span class="publish-status__indicator" :data-state="postStatus"></span>
                                <strong>Status: </strong> {{ postStatusText }}
                            </div>

                            <div class="publish-status">
                                <i class="icon ion-ios-calendar"></i>
                                <strong>{{ publishStatusTimeframe }}: </strong> {{postPublishDate}} <a href="#" v-on:click.stop.prevent="openModal('post-settings')">Edit</a>
                            </div>

                            <div class="publish-status">
                                <i class="icon ion-ios-mail"></i>
                                <strong>Notify: </strong> {{ notifyStatusText }} <a href="#" v-if="post.status !== 2" v-on:click.stop.prevent="openModal('post-settings')">Edit</a>
                            </div>

                            <div class="modal micromodal-slide" id="post-settings" aria-hidden="true">
                                <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                                    <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                                        <div class="modal__content" id="modal-post-settings-content">
                                            <h3>Excerpt</h3>
                                            <textarea v-model="post.excerpt" rows="5" class="form__control"></textarea>

                                            <h3 v-if="post.status !== 2">Notify users via Email when published</h3>
                                            <input v-if="post.status !== 2" type="checkbox" name="notify" v-model="post.notify" value="1">

                                            <h3>Publish date</h3>
                                            <flat-pickr
                                                v-model="post.published_at"
                                                class="form__control"
                                                :config="config_datepicker"
                                            ></flat-pickr>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button class="btn btn-success btn-block" v-on:click.stop.prevent="saveDocument(2)" type="submit" value="publish">
                                <span>{{ buttonText }}</span>
                            </button>
                            <span class="last_saved" v-if="post.updated_at"><i class="saving-spinner" :class="{ active: loading}"></i> Last saved: {{ lastUpdatedTime }}</span>

                            <h3>Featured Image</h3>
                            <div class="publish-featured">
                                <file-upload
                                    name="featured-image-upload"
                                    v-model="post.featured_image"
                                    :group="group"
                                    type="image" />

                                <a href="#" v-on:click.stop.prevent="openModal('image-settings')">Preview image</a>

                                <div class="modal micromodal-slide" id="image-settings" aria-hidden="true">
                                    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                                        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-image-settings">
                                            <div class="modal__content" id="modal-image-settings-content">
                                                <div style="width: 290px;">
                                                    <post-card v-if="post.meta" :post="post" :group="post.group" :contain="post.meta.featured_image_contain"></post-card>
                                                </div>

                                                <div class="publish-status" v-if="post.meta">
                                                    <strong>Contain the image with the area: </strong>
                                                    <input type="checkbox" name="featured_image_contain" v-model="post.meta.featured_image_contain" value="1">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h3>Category</h3>
                            <div class="select">
                                <select class="form__control" @change="updateCategoryOnChange">
                                    <option value="">Not categorised</option>
                                    <option v-for="(cat, index) in group.categories" :value="index" :selected="isSelected(cat)">{{ cat.name }}</option>
                                </select>
                            </div>
                            <h3>Featured</h3>
                            <div>
                                <label for="featured_post">Feature this post</label>
                                <input type="checkbox" id="featured_post" name="featured_post" v-model="post.featured" value="0">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import LayoutBase from '../../layouts/LayoutBase';
    import MicroModal from 'micromodal';
    import { format, parse, differenceInMilliseconds, formatDistanceToNow} from 'date-fns';

    export default {
        components: {
            LayoutBase
        },
        data(){
            return {
                editPostURL: '/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post,
                createPostURL: '/api/groups/' + this.$route.params.group + "/posts",
                loading: 0,
                publishedDateChanged: false,
                selectedCategory: null,
                post: {
                    id: null,
                    title: "",
                    status: 0,
                    content: "",
                    excerpt: "",
                    featured_image: null,
                    featured: false,
                    authors: [],
                    meta: {
                        featured_image_contain: false,
                    },
                    published_at: null,
                    notify: false,
                    event: {
                        venue: null,
                        starts: null,
                        ends: null,
                        google_place_id: null
                    },
                    categories: [],
                    group:{
                        type: null
                    }
                },
                config_datepicker: {
                    altInput: true,
                    altFormat: 'j M Y @ H:i:S',
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i:S',
                    time_24hr: true,
                    defaultDate: new Date()
                },
                venuePredictions: [],
                venue_search: null,
                chosenVenue: null,
                category: null,
                currentTime: new Date()
            }
        },
        watch: {
            chosenVenue: {
                handler() {
                    this.populateVenue( this.chosenVenue );
                }
            }
        },
        computed: {
            ...mapState({
                group: state => state.group.group,
                sidebarPosts: state => state.group.posts
            }),
            lastUpdatedTime: function(){
                var date = parse(this.post.updated_at, 'yyyy-MM-dd HH:mm:ss', this.currentTime);
                return formatDistanceToNow(date, {includeSeconds: true, addSuffix: true});
            },
            // What should the publish button text be?
            buttonText: function(){
                return (this.post.status === 2)? 'Update' : 'Publish';
            },
            // Sets the class for the post status indicator/light
            postStatus: function() {
                if( this.post.status === 0 ){
                    return 'unsaved';
                }

                if( this.post.status === 1 ){
                    return 'draft';
                }

                return 'published'
            },
            // Sets the text for the post status indicator
            postStatusText: function() {
                if( this.post.status === 0 ){
                    return 'Un-Saved';
                }

                if( this.post.status === 1 ){
                    return 'Draft';
                }

                return 'Published';
            },
            notifyStatusText: function() {
                if( this.post.notify === true ){
                    return 'Everyone';
                }

                return '';
            },
            // Sets the text for the publish date of the post
            postPublishDate: function() {
                if( this.post.published_at !== null){
                    return this.post.published_at;
                }

                return 'Immediately';
            },
            publishStatusTimeframe: function() {
                if( this.post.published_at !== null){
                    var today = new Date();
                    var future = parse(this.post.published_at, 'yyyy-MM-dd HH:mm:ss', new Date());

                    if( differenceInMilliseconds(future, today) > 0 ){
                        return 'Scheduled';
                    }
                }

                if( this.post.status === 2){
                    if( this.post.published_at ){
                        return 'Published';
                    }
                }

                return 'Publish';
            }
        },
        created(){
            var self = this;

            if (this.$route.params.post && this.$route.params.post !== 'new-post' && this.$route.params.post !== 'undefined') {
                this.getPost();
            }

            if (this.$route.params.group) {
                this.getGroup(this.$route.params.group);
            }

            if( this.$route.params.category ) {
                this.category = this.$route.params.category;
                this.$store.commit('group/setActiveCategory', this.$route.params.category);
            }

            setInterval(function () {
                self.currentTime = new Date();
            }, 3000)
        },
        mounted(){
            MicroModal.init({
                disableScroll: true
            });

            // Resizes the title field
            document.querySelectorAll('.title-input').forEach( (title) => {
                var offset = title.offsetHeight - title.clientHeight;

                this.resizeTextarea(title);

                title.addEventListener('keyup', (value) => {
                    this.resizeTextarea(title);
                });
            });
        },
        methods: {
            ...mapActions({
                getGroup: 'group/getGroup',
                getPosts: 'group/getPosts',
            }),
            updateEndDateOnChange(selectedDates){
                if(this.post.event.ends === null){
                    var date = format(selectedDates[0], 'yyyy-MM-dd HH:mm:ss');
                    this.post.event.ends = date;
                }
            },
            updateCategoryOnChange(el){
                if(el.target.value !== ""){
                    this.post.categories[0] = this.group.categories[el.target.value];
                }
            },
            isSelected(cat){
                if(this.post.categories && this.post.categories[0]){
                    if(cat.id === this.post.categories[0].id){
                        return true;
                    }
                }else{
                    if(this.$route.params.category){
                        if(cat.slug === this.$route.params.category){
                            this.post.categories[0] = cat;
                            return true;
                        }
                    }
                }

                return false;
            },
            // For field blurs when we want to save
            maybeSave(el) {
                if( el.target.value ){
                   this.saveDocument();
                }
            },
            // Resizes the title field
            resizeTextarea(el) {
                el.style.cssText = 'height:auto; padding:0; box-sizing: border-box';
                el.style.cssText = 'height:' + el.scrollHeight + 'px';
            },
            // Adds an author to a post
            addAuthor(author){
                this.post.authors.push(author);
            },
            // Removes an author from a post
            removeAuthor(authorID){
                this.post.authors = this.post.authors.filter(function( obj ) {
                    return obj.id !== authorID;
                });
            },
            openModal(modal){
                MicroModal.show(modal);
            },
            // Get the Post
            getPost() {
                axios.get('/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post).then((response) => {
                    this.post = response.data;

                    setTimeout(() => {
                        this.resizeTextarea(document.querySelectorAll('.page-header .title-input')[0]);
                    });
                }, (response) => {
                    this.error = response;
                });
            },
            updateDocument(){
                if( this.post.status !== 2){
                    this.saveDocument();
                }
            },
            // Put or post the Post
            saveDocument($status = null){
                this.loading = 1;

                // If the post status is un-saved turn it into a draft
                if( this.post.status === 0 ){
                    this.post.status = 1;
                }

                // If we're publishing set the correct value
                if( $status === 2 ){
                    if( this.post.published_at === null){
                        this.post.published_at = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    }

                    this.post.status = 2;
                }

                if(this.post.slug){
                    axios.put(this.editPostURL, this.post).then((response) => {
                        this.post = response.data;
                        this.loading = 0;

                        if(this.group.type === "2" && this.$route.params.category){
                            this.getPosts({ group: this.$route.params.group, category: this.$route.params.category});
                        }
                        
                        if( window.sessionStorage ){
                            window.sessionStorage.removeItem('group:' + this.$route.params.group);
                            window.sessionStorage.removeItem('group:' + this.$route.params.group + ':expires');
                        }
                    }, (response) => {
                        this.error = response;
                    });
                }else{
                    axios.post(this.createPostURL, this.post).then((response) => {
                        this.post = response.data;
                        this.$router.push({ name: 'edit-post', params: { group: this.$route.params.group, post: this.post.slug }});
                        this.loading = 0;
                        this.editPostURL = '/api/groups/' + this.$route.params.group + "/posts/" + this.post.slug;

                        if( this.group.type === "2" && this.$route.params.category ){
                            this.getPosts({ group: this.$route.params.group, category: this.$route.params.category});
                        }

                        if( window.sessionStorage ){
                            window.sessionStorage.removeItem('group:' + this.$route.params.group);
                            window.sessionStorage.removeItem('group:' + this.$route.params.group + ':expires');
                        }

                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            getVenuePredictions() {
                axios.get('/api/get-venues?search=' + this.venue_search).then((response) => {
                    this.venuePredictions = response.data.predictions;
                }, (response) => {
                    this.error = response;
                });
            },
            populateVenue( venue ){
                this.post.event.venue = this.venuePredictions[venue].description;
                this.post.event.google_place_id = this.venuePredictions[venue].place_id;
            },
            resetVenue(){
                this.post.event.venue = null;
            }
        },
        beforeRouteLeave (to, from , next) {
            // const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            //      if (answer) {
                        next()
            //      } else {
            //          next(false)
            //      }
        }
    }
</script>

<style lang="scss">
    .publish_date{
        align-items: center;

        input{
            max-width: 80px;
            margin: 0 5px;
        }
    }

    .saving-spinner {
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px
    }

    .last_saved{
        display: block;
        margin-top: 10px;
    }

    .saving-spinner:after {
        content: "";
        opacity: 0;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        filter: alpha(opacity=0);
        border: 0;
        width: 0;
        position: relative;
        top: -1px;
        vertical-align: middle;
        -webkit-transition: width .2s linear,margin .2s linear;
        transition: width .2s linear,margin .2s linear;
        display: block
    }

    .saving-spinner.active:after {
        -webkit-transition: width .2s linear,margin .2s linear,opacity .5s ease-in;
        transition: width .2s linear,margin .2s linear,opacity .5s ease-in;
        opacity: 1;
        -ms-filter: none;
        -webkit-filter: none;
        filter: none;
        width: 10px;
        height: 10px;
        -webkit-animation: fa-spin 2s linear infinite;
        animation: fa-spin 2s linear infinite;
        border-radius: 50%;
        border-color: rgba(85,85,85,.6) rgba(85,85,85,.6) #546b81 #546b81;
        border-style: solid;
        border-width: 2px;
        margin-right: 5px
    }

    .predictions{
        margin: 10px 0;

        .prediction{
            border: 1px solid #ededed;
            padding: 16px;
            margin: 5px 0;
            display: flex;
            align-items: center;

            input{
                margin-right: 10px;
            }
        }
    }
</style>
